export interface UpdateDefaultParameterOrderRequest {
  id: string
  orderDate: string
  collectionType: string
  traderCode: string
  acceptType: string
  buyDepartmentCode: string
  donorCode: string
  budgetYear: number | string
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
  revision: number
  allBranchFlag: boolean
}

export function UpdateDefaultParameterOrderRequestToJSON(
  value: UpdateDefaultParameterOrderRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    order_date: value.orderDate !== '' ? value.orderDate : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    buy_department_code:
      value.buyDepartmentCode !== '' ? value.buyDepartmentCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    budget_year: value.budgetYear !== '' ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    revision: value.revision ? value.revision : undefined,
    all_branch_flag: value.allBranchFlag
  }
}
